import React, { Component, Fragment } from "react";
import { components } from "react-select";
import AsyncSelect from 'react-select/async';

const ValueContainer = ({ children, ...props }) => {

    return (
        components.ValueContainer && (
            <components.ValueContainer {...props}>
                {!!children && (
                    <i
                        className={props.selectProps.icon ? props.selectProps.icon : ''}
                        aria-hidden="true"
                        style={{ position: "absolute", left: 6 }}
                    />
                )}
                {children}
            </components.ValueContainer>
        )
    );
};

const styles = {
    valueContainer: base => ({
        ...base,
        paddingLeft: 28
    })
}

// react-select's menu defaults to z-index 1, the same as Bootstrap's .custom-control, so a
// switch or checkbox rendered after the select painted over the open list. 1000 matches
// Bootstrap's dropdown layer.
const menuStyles = {
    menu: base => ({
        ...base,
        zIndex: 1000
    })
}

export default class CustomSelectAsync extends Component {

    state = {
        value: this.props.value || ""
    };

    selectRef = null;
    setSelectRef = ref => {
        this.selectRef = ref;
    };

    onChange = (value, actionMeta) => {
        this.props.onChange(value, actionMeta);
        this.setState({ value });
        this.props.onChange(value)
    };

    getValue = () => {
        if (this.props.value !== undefined) return this.props.value;
        return this.state.value || "";
    };

    clear() {
        this.setInputValue('');
    }


    render() {
        const { SelectComponent, required, ...props } = this.props;
        const { isDisabled } = this.props;
        const enableRequired = !isDisabled;
        const components = { ValueContainer };
        return (
            <Fragment>
                <AsyncSelect
                    {...props}
                    ref={this.setSelectRef}
                    onChange={this.onChange}
                    components={components}
                    styles={props.icon ? { ...styles, ...menuStyles } : menuStyles}

                />
                {enableRequired && (
                    <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{
                            opacity: 0,
                            // width 0: validation-only input; 100% overflowed the page on
                            // screens without a positioned ancestor
                            width: 0,
                            height: 0,
                            position: "absolute"
                        }}
                        value={this.getValue()}
                        onChange={() => { }}
                        onFocus={() => this.selectRef.focus()}
                        required={required}

                    />
                )}
            </Fragment>
        );
    }
}